<div class="header-wrapper" [ngClass]="{ edit: mode != undefined, mobile: rwdService.isSmallDevice }">
  <h1 [ngSwitch]="mode">
    <span *ngSwitchCase="undefined" class="header">{{ headerValue | locLabel }} </span>
    <span *ngSwitchCase="UpdateMode.ADD" class="header">{{ addTitleValue | locLabel }}</span>
    <span *ngSwitchCase="UpdateMode.MODIFY" class="header">{{ editTitleValue | locLabel }}</span>
    <app-tooltip [tooltipKey]="tooltipValue" *ngIf="tooltipValue"></app-tooltip>
  </h1>
  <div class="actions">
    <ng-content></ng-content>
  </div>
  <button *ngIf="mode != undefined" mat-icon-button class="close-icon" type="button" [routerLink]="exitLink">
    <mat-icon inline>close</mat-icon>
  </button>
</div>
